export const uploadConsentsActionConstants = {
  ADD_CONSENT   : 'ADD_CONSENT',
  REMOVE_CONSENT: 'REMOVE_CONSENT',
}

export const addUploadConsent    = (psId, ins, fullName, birthday) => ({
  type: uploadConsentsActionConstants.ADD_CONSENT,
  ins,
  psId,
  fullName,
  birthday
})
export const removeUploadConsent = (psId, ins) => ({
  type: uploadConsentsActionConstants.REMOVE_CONSENT,
  ins,
  psId,
})
